const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function calculateCostBreakdown(price: number, creditAmount: number) {
  const totalPrice = price - creditAmount;
  const formattedTotalPrice = formatter.format(
    totalPrice <= 0 ? 0 : totalPrice,
  );
  const formattedPrice = formatter.format(price);
  const formattedCreditAmount = formatter.format(creditAmount);

  return {
    formattedCreditAmount,
    formattedPrice,
    formattedTotalPrice,
  };
}
